
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"currentColor","stroke-width":"1.304","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M1.964 13.696v-3.261c0-4.683 3.82-8.478 8.532-8.478 4.711 0 8.53 3.795 8.53 8.478v3.26"}}),_c('path',{attrs:{"d":"M20.29 18.297a1.304 1.304 0 01-.926 1.6c-.26.07-.538.058-.792-.034a24.696 24.696 0 00-8.076-1.602c-2.764.078-5.494.62-8.076 1.602a1.315 1.315 0 01-1.684-.778 1.296 1.296 0 01-.034-.788l1.263-4.6a37.055 37.055 0 018.53-1.304c2.886.101 5.75.54 8.532 1.304l1.263 4.6zm-9.794-16.34V.652m.003 3.913a2.617 2.617 0 012.625 2.61 2.617 2.617 0 01-2.625 2.608 2.617 2.617 0 01-2.625-2.609 2.617 2.617 0 012.625-2.609z"}})])])
          )
        }
      }
    